import React, { useState } from 'react';

import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import { LayoutContainer } from 'components/layout/styled';
import { useNavigation } from 'hooks/navigation/use-navigation';
import useErrorModal from 'hooks/use-error-modal';
import { AuthContainer } from 'pages/authentication/components/auth-container';
import { useAuthContext } from 'state/auth';
import { isEmailValid } from 'utils/form';

import { CenteredText, Heading } from './styled';

interface IMissingLinkProps {
  username: string;
}

const MissingLink: React.FC<React.PropsWithChildren<IMissingLinkProps>> = ({ username }) => {
  const { signIn } = useAuthContext();
  const { formatMessage } = useIntl();
  const [resendEmailIsLoading, setResendEmailIsLoading] = useState(false);
  const { navigate } = useNavigation();
  // @ts-ignore
  const [ErrorDialog, openErrDialog] = useErrorModal({
    onConfirm: () => navigate('/signin'),
    modalAppearanceEventMessage: 'Error: Invalid Password Reset Email Provided',
  });

  const newLinkText = formatMessage({ id: 'authNewLink' });
  const sendNewLinkText = formatMessage(
    { id: 'authExpiredLink' },
    {
      sendNewLinkText: newLinkText,
    }
  );

  const resendEmailLink = async () => {
    setResendEmailIsLoading(true);
    if (!username || !isEmailValid(username)) {
      setResendEmailIsLoading(false);
      openErrDialog({
        message: formatMessage({ id: 'invalidEmailProvided' }),
      });
    } else {
      try {
        await signIn({
          email: username,
          navigateOnSuccessParams: { email: username },
        });
      } catch (error) {
        setResendEmailIsLoading(false);
        openErrDialog({
          message: formatMessage({ id: 'authError' }),
        });
      }
    }
  };

  return (
    <LayoutContainer>
      <AuthContainer>
        <Heading>{formatMessage({ id: 'authMissingLink' })}</Heading>
        <CenteredText>{sendNewLinkText}</CenteredText>
        <ActionButton
          testID="missing-link-button"
          isLoading={resendEmailIsLoading}
          onPress={resendEmailLink}
        >
          {newLinkText}
        </ActionButton>
      </AuthContainer>
      <ErrorDialog buttonLabel={formatMessage({ id: 'tryAgain' })} />
    </LayoutContainer>
  );
};

export default MissingLink;
